module.exports = __webpack_public_path__ + "img/generic.c5431c94.png";